// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .selected-package::after {
    content: "";
    position: absolute;
    top: -1px;
    right: -1px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 15px 15px 0 0;
    border-color: #007bff transparent transparent transparent;
}

.selected-package {
    background-color: #e9f7fd !important;
    border: 2px solid #007bff !important;
    position: relative;
    cursor: pointer;
}

.package-row {
    background-color: #fff;
    border: 1px solid #e9ecef;
    cursor: pointer;
}

thead tr {
    background-color: #007bff;
    color: white;
}

td {
    padding: 12px;
    font-size: 14px;
    text-align: center;
} */
.skeleton {
    width: 100%;
    height: 20px;
    background: #f0f0f0;
    border-radius: 4px;
    margin-bottom: 10px;
    animation: shimmer 1.5s infinite linear;
}

@keyframes shimmer {
    0% { background-position: -200px 0; }
    100% { background-position: 200px 0; }
}
.filter-item {
}

.filter-item:hover {
    background-color: #007bff !important; /* Chuyển thành màu xanh */
    color: white !important; /* Chữ trắng khi hover */
}
`, "",{"version":3,"sources":["webpack://./src/pages/Product/Server/package.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAkCG;AACH;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,uCAAuC;AAC3C;;AAEA;IACI,KAAK,6BAA6B,EAAE;IACpC,OAAO,4BAA4B,EAAE;AACzC;AACA;AACA;;AAEA;IACI,oCAAoC,EAAE,0BAA0B;IAChE,uBAAuB,EAAE,wBAAwB;AACrD","sourcesContent":["/* .selected-package::after {\n    content: \"\";\n    position: absolute;\n    top: -1px;\n    right: -1px;\n    width: 0;\n    height: 0;\n    border-style: solid;\n    border-width: 15px 15px 0 0;\n    border-color: #007bff transparent transparent transparent;\n}\n\n.selected-package {\n    background-color: #e9f7fd !important;\n    border: 2px solid #007bff !important;\n    position: relative;\n    cursor: pointer;\n}\n\n.package-row {\n    background-color: #fff;\n    border: 1px solid #e9ecef;\n    cursor: pointer;\n}\n\nthead tr {\n    background-color: #007bff;\n    color: white;\n}\n\ntd {\n    padding: 12px;\n    font-size: 14px;\n    text-align: center;\n} */\n.skeleton {\n    width: 100%;\n    height: 20px;\n    background: #f0f0f0;\n    border-radius: 4px;\n    margin-bottom: 10px;\n    animation: shimmer 1.5s infinite linear;\n}\n\n@keyframes shimmer {\n    0% { background-position: -200px 0; }\n    100% { background-position: 200px 0; }\n}\n.filter-item {\n}\n\n.filter-item:hover {\n    background-color: #007bff !important; /* Chuyển thành màu xanh */\n    color: white !important; /* Chữ trắng khi hover */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
